import { Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from '@chakra-ui/react'

import Card from 'components/Card/Card'
import CardHeader from 'components/Card/CardHeader'
import CardBody from 'components/Card/CardBody'

import Timeline from './Timeline'
import Charts from './Charts'
import Files from './Files'
import Notes from './Notes'
import { Life } from 'interfaces/life'
import Glucose from './Glucose'

interface Props {
    life: Life
    isLoading: boolean
}

const Folders = ({ life, isLoading }: Props) => {
    const assessments = life?.assessments;
    const tabTextColor = useColorModeValue('gray.600', 'gray.300')
    const tabOutlineColor = useColorModeValue('blackAlpha.400', 'whiteAlpha.400')

    const decodedJson = !life.integration_identifiers ? '' : JSON.parse(life?.integration_identifiers);
    const cpf = decodedJson[0]?.cpf || '';

    const tabProps = {
        color: tabTextColor,
        outline: '1px solid',
        outlineColor: tabOutlineColor,
        marginRight: '12px',
        transition: '.4s all ease'
    }

    return (
        <Card minHeight="100px" overflowX={{ sm: "auto", lg: "unset" }}>
            <Tabs variant='soft-rounded' colorScheme='green' isLazy>
                <CardHeader mb="12px">
                    <TabList >
                        <Tab {...tabProps} >Indicadores</Tab>
                        <Tab {...tabProps} >Timeline</Tab>
                        <Tab {...tabProps} >Glicemia</Tab>
                        {/* <Tab {...tabProps} >Registro de Notas</Tab>
                        <Tab {...tabProps} >Arquivos</Tab> */}
                    </TabList>
                </CardHeader>
                <CardBody h="100%" px="0px">
                    <TabPanels>
                        <TabPanel px={0}>
                            <Charts life={life} isLoading={isLoading} />
                        </TabPanel>
                        <TabPanel px={0}>
                            <Timeline assessments={assessments} isLoading={isLoading} />
                        </TabPanel>
                        <TabPanel>
                            <Glucose registration_number={life.document} cpf={cpf} />
                        </TabPanel>
                        <TabPanel px={0}>
                            <Notes />
                        </TabPanel>
                        <TabPanel px={0}>
                            <Files />
                        </TabPanel>
                    </TabPanels>
                </CardBody>
            </Tabs>
        </Card>
    )
}

export default Folders